import { type SvgProps, SvgWrapper } from '../utils';

export function LineChartIcon(props: SvgProps) {
  return (
    <SvgWrapper {...props}>
      <path d="M2.25 19V3C2.25 2.58579 2.58579 2.25 3 2.25C3.41421 2.25 3.75 2.58579 3.75 3V19C3.75 19.3315 3.88179 19.6494 4.11621 19.8838C4.35063 20.1182 4.66848 20.25 5 20.25H21C21.4142 20.25 21.75 20.5858 21.75 21C21.75 21.4142 21.4142 21.75 21 21.75H5C4.27065 21.75 3.57139 21.4601 3.05566 20.9443C2.53994 20.4286 2.25 19.7293 2.25 19Z" />
      <path d="M18.4697 8.46973C18.7626 8.17683 19.2374 8.17683 19.5303 8.46973C19.8232 8.76262 19.8232 9.23738 19.5303 9.53027L14.5303 14.5303C14.2374 14.8232 13.7626 14.8232 13.4697 14.5303L10 11.0605L7.53027 13.5303C7.23738 13.8232 6.76262 13.8232 6.46973 13.5303C6.17683 13.2374 6.17683 12.7626 6.46973 12.4697L9.46973 9.46973L9.52637 9.41797C9.82095 9.17766 10.2557 9.19512 10.5303 9.46973L14 12.9395L18.4697 8.46973Z" />
    </SvgWrapper>
  );
}
